import { Box, Typography } from '@mui/material';
import { useState, useRef, useEffect } from 'react';
import { HoverExpandableContainer, StatusChip } from '../../../common/components';

const HOVER_OFFSET = 8;
const MAX_CONTENT_HEIGHT = 220;

const HoverExpandableSubscribers = ({ subscribers = [] }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [anchorRect, setAnchorRect] = useState(null);
  const [placement, setPlacement] = useState('bottom');
  const containerRef = useRef(null);

  const updateOverlayPosition = () => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const availableBottom = window.innerHeight - rect.bottom;
    const newPlacement = availableBottom < MAX_CONTENT_HEIGHT ? 'top' : 'bottom';
    setPlacement(newPlacement);
    setAnchorRect(rect);
  };

  useEffect(() => {
    if (!isHovered) return;

    updateOverlayPosition();
    window.addEventListener('scroll', updateOverlayPosition, true);
    window.addEventListener('resize', updateOverlayPosition);

    return () => {
      window.removeEventListener('scroll', updateOverlayPosition, true);
      window.removeEventListener('resize', updateOverlayPosition);
    };
  }, [isHovered]);

  if (!subscribers || subscribers.length === 0) return null;

  const subscribersArray = Array.isArray(subscribers) ? subscribers : [subscribers];
  const additionalCount = subscribersArray.length - 1;

  return (
    <Box
      ref={containerRef}
      sx={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => {
        setIsHovered(true);
        updateOverlayPosition();
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        setAnchorRect(null);
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" component="span">
          {subscribersArray[0]}
        </Typography>
        {subscribersArray.length > 1 && (
          <StatusChip
            label={`+${additionalCount}`}
            color="primary"
            variant="active"
            size="small"
          />
        )}
      </Box>

      {subscribersArray.length > 1 && isHovered && anchorRect && (
        <HoverExpandableContainer
          anchorRect={anchorRect}
          placement={placement}
          offset={HOVER_OFFSET}
        >
          {subscribersArray.map((subscriber, index) => (
            <Typography
              key={index}
              variant="body2"
              sx={{
                paddingY: 0.5,
                marginBottom: index < subscribersArray.length - 1 ? '4px' : '0',
              }}
            >
              {subscriber}
            </Typography>
          ))}
        </HoverExpandableContainer>
      )}
    </Box>
  );
};

export default HoverExpandableSubscribers;
